// This file was auto-generated by Fern from our API Definition.
/** Gateway route namespace. */
export const GatewayEndpointNamespace = {
    Builtin: "builtin",
    Standard: "standard",
    Custom: "custom",
};
